import {
  WEBSITE_EDITOR_SECTIONS,
  websiteEditorDestination as canonicalWebsiteEditorDestination,
  type WebsiteEditorSection,
} from "@shared/websiteEditorDestinations";

export { WEBSITE_EDITOR_SECTIONS, type WebsiteEditorSection };
export const websiteEditorDestination = canonicalWebsiteEditorDestination;

export function websiteEditorControlDestination(
  section: WebsiteEditorSection,
  control: string,
): string {
  const params = new URLSearchParams(canonicalWebsiteEditorDestination(section).split("?")[1]);
  params.set("control", control);
  return `/website?${params.toString()}`;
}
